import React from 'react'
import { StaticQuery, graphql, Link } from 'gatsby'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import Container from '../../Container'
import ArticleCard from '../ArticleCard'
import { ButtonArrow } from '../../../shared/Buttons/Buttons.styles'
import { Title, SliderContainer, BlackButton } from './ArticleCarousel.style'
import ArrowRight from '../Icons/ArrowRight'

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
}

const ArticleSlider = ({ data }) => (
  <SliderContainer>
    <Slider {...settings}>
      { data.edges &&
        data.edges.map(item => {
          const article = item.node
          return (
            <ArticleCard
              key={article.id}
              title={article.title}
              slug={article.slug}
              body={article.body}
              category={article.categories}
              featuredImage={article.featuredImage}
            />
          )
        })
      }
    </Slider>
  </SliderContainer>
)

const ArticleCarousel = ({ hideTitle, title, ctaText, articleCarouselLink }) => (
  <Container>
    {
      hideTitle ? (!hideTitle && <Title>{title}</Title>) : <Title>{title}</Title>
    }
    <StaticQuery
      query={
        graphql`
          query FeaturedArticlesQuery {
            allContentfulArticle (
              limit: 5
              filter: {
                setFeaturedArticle: {eq: true}
                slug: {
                  nin: ["", null]
                }
                title: {
                  nin: ["", null]
                }
                node_locale: {
                  eq: "en-US"
                }
              }
              sort: {fields: [publishDate], order: DESC})
            {
              edges {
                node {
                  ...ArticleCardFragment
                }
              }
            }
          }
        `}
      render={({ allContentfulArticle }) => {
        return (
          <ArticleSlider data={allContentfulArticle} />
        )
      }}
    />
    { articleCarouselLink && articleCarouselLink.slug !== '' && (
      <BlackButton>
        <Link to={articleCarouselLink.slug}>
          {ctaText}
          <ButtonArrow viewBox="0 0 12 21"><ArrowRight /></ButtonArrow>
        </Link>
      </BlackButton>
    )}
  </Container>
)

export const ArticleCarouselFragment = graphql`
  fragment ArticleCarouselFragment on ContentfulArticleCarousel {
    title
    ctaText
    articleCarouselLink {
      slug
    }
    hideTitle
  }
`

ArticleCarousel.propTypes = {
  title: PropTypes.string.isRequired,
  ctaText: PropTypes.string,
  articleCarouselLink: PropTypes.shape({
    slug: PropTypes.string,
  }),
  hideTitle: PropTypes.bool,
}

ArticleSlider.propTypes = {
  data: PropTypes.shape({
    slug: PropTypes.string,
    category: PropTypes.shape({
      title: PropTypes.string,
    }).isRequired,
    featuredImage: PropTypes.shape({
      fluid: PropTypes.object,
    }),
    title: PropTypes.string,
    body: PropTypes.shape({
      childMarkdownRemark: PropTypes.shape({
        excerpt: PropTypes.string,
      }),
    }),
  }).isRequired,
}

ArticleCarousel.defaultProps = {
  ctaText: '',
  articleCarouselLink: null,
  hideTitle: false,
}

export default ArticleCarousel
